var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Checkbox from '../Checkbox';
import SortableTableCell from './SortableTableCell';
/**
 * Table Header. Can be used in Table component
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/develop/v0.3.0/components/datatable.md
 */
export default function Header(_a) {
    var selectable = _a.selectable, checked = _a.checked, handleSelectAllChange = _a.handleSelectAllChange, cells = _a.cells, filters = _a.filters, handleSort = _a.handleSort;
    return (React.createElement("tr", { className: "mdc-data-table__header-row" },
        selectable && (React.createElement("th", { className: "mdc-data-table__header-cell select-cell", role: "columnheader", scope: "col" },
            React.createElement(Checkbox, { checked: checked === 1, onChange: handleSelectAllChange, indeterminate: checked === 0, "aria-label": "select all rows" }))),
        cells.map(function (cell, key) { return (React.createElement("th", { className: "mdc-data-table__header-cell", role: "columnheader", scope: "col", key: "data-table-header-cell-" + key },
            React.createElement(SortableTableCell, __assign({}, cell, { filters: filters, handleSort: handleSort })))); })));
}
//# sourceMappingURL=Header.js.map